/* eslint-disable jsx-a11y/anchor-is-valid */
import cn from 'classnames';
import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { requestSearchValue } from '../../redux/actions/main-page';
import { RootState } from '../../redux/reducers/rootReducer';
import { HEADER_LINKS, TO_LINK } from '../../utils/constants/main-header-links';
import mediaQueries from '../../utils/media-query/media-query-constants';
import useMediaQuery from '../../utils/media-query/media-query-hook';
import Link from '../Link';
import MobileMenu from '../MobileMenu';
import HeaderLogo from '../SVGIcons/HeaderLogo';
import MobileMenuIconNew from '../SVGIcons/MobileMenuIconNew';
import classes from './HeaderCatalog.module.scss';

interface HeaderCatalogProps {
  colored?: boolean;
  isSticked: boolean;
  className?: string;
  isAbsolute?: boolean;
}

function HeaderCatalog({
  colored,
  isSticked,
  className,
  isAbsolute,
}: HeaderCatalogProps) {
  const isMobile = useMediaQuery(mediaQueries.mobile);
  const isMobileSearchOpen = useSelector<RootState, boolean | undefined>(
    (state) => state.mainReducer.isSearchOpen,
  );

  const [isMobileMenuShown, setMobileMenuShown] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const dispatch = useDispatch();

  const scrollTrigger = !isMobile ? 16 : 8;
  const style = { '--headerBackground': colored ? 'white' : 'none' };

  const handleScroll = () => {
    setIsScrolled(
      window.scrollY >= scrollTrigger || window.pageYOffset >= scrollTrigger,
    );
  };

  const closeMobileMenu = () => {
    setMobileMenuShown(false);
  };

  const resetSearch = () => {
    dispatch(requestSearchValue({ searchValue: '' }));
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    setIsScrolled(
      window.scrollY >= scrollTrigger || window.pageYOffset >= scrollTrigger,
    );
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (isMobileSearchOpen) return null;

  return (
    <div
      id="header"
      style={{ ...style, visibility: 'visible' }}
      className={cn(
        {
          [classes.header]: true,
          [classes.sticked]: isSticked,
          [classes.scrolled]: isScrolled,
          [classes.absolute]: isAbsolute,
        },
        className,
      )}
    >
      <div className={classes.header__container}>
        <NavLink style={{ height: isMobile ? 24 : undefined }} to="/">
          <HeaderLogo />
        </NavLink>
        <div className={classes.links}>
          {isMobile ? (
            <>
              <div
                className={classes.mobileMenu}
                role="none"
                onClick={() => setMobileMenuShown(true)}
              >
                <MobileMenuIconNew fill="white" />
              </div>
              <MobileMenu shown={isMobileMenuShown} onClose={closeMobileMenu} />
            </>
          ) : (
            HEADER_LINKS.map((link) => (
              <Link
                key={link.id}
                typeColor="black"
                isActive={link.to === TO_LINK.CATALOG_VACANCIES}
                title={link.title}
                route={link.to}
                isNavLink={link.isNavLink}
                onClick={resetSearch}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default memo(HeaderCatalog);
